import { useEffect, useState } from 'react';

const useAppbannerHeight = () => {
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    const containerElement = document.getElementById('appsflyer-container');
    if (!containerElement) return;

    if (typeof ResizeObserver === 'undefined') return;

    const resizeObserver = new ResizeObserver((entries) => {
      setBannerHeight(entries[0]?.contentRect.height);
    });

    resizeObserver.observe(containerElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return bannerHeight;
};

export default useAppbannerHeight;
